import React from 'react';
import './courseAssignments.css'
import C2wCircleHightlightCrd from '../../../../common/C2wHome/courseDetails/circleHightlightCrd';
import C2wCourseDetailsTopicCard from '../../../../common/C2wHome/courseDetails/courseDetailsTopicCard';

function C2wCourseAssignments({ courseData }) {
  return (
    <div className='C2wCourseAssignments_ctn'>
      <div className='C2wCoureseDetailComponentHeading_ctn'>
        <div className='heading'>
          {`${'We provide '} `}
          <span className='headingSpan'>{`${'Assignments on each topic '}`}</span>
          {'along with solutions.'}
        </div>
      </div>
      <div className='C2wCourseAssignments_Circlecrd_hld'>
        {courseData?.assignmentCountArray?.map((obj, index) => (
          <C2wCircleHightlightCrd obj={obj} />
        ))}
      </div>
      <div className='C2wCourseAssignments_crds_hld'>
        {courseData?.assignmnetsTopicsArray?.map((obj, i) => (
          <C2wCourseDetailsTopicCard obj={obj} i={i}/>
        ))}

      </div>
    </div>
  )
}

export default C2wCourseAssignments